import loanFormModel from '../../../components/loan_application/form_models/loanFormModel';
import { genericRequiredFieldError } from '../../../constants';
import { ValidationSchema } from '../../../validations/interfaces';
import { Validation } from '../../../validations/Validation';
import * as Yup from 'yup';

const {
  formField: { loanYearOfMaturity, onSystemProperty },
} = loanFormModel;

export class MortgageLoanYearOfMaturityValidation implements ValidationSchema {
  public name = loanYearOfMaturity.name;
  public label = '';
  public dependsOn: string[] = [onSystemProperty.name];
  public type = 'number';
  public required = {
    message: genericRequiredFieldError,
    value: true,
  };
  public nullable = true;
  public min = {
    message: 'Loan maturity year cannot be in the past',
    value: new Date().getFullYear(),
  };

  public typeError = {
    message: genericRequiredFieldError,
    value: true,
  };

  public when(
    onSystemProperty: string,
    schema: Yup.NumberSchema,
    context: any
  ) {
    if (onSystemProperty === 'Yes') {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new MortgageLoanYearOfMaturityValidation());
